/**
 * HOS API
 *
 *
 * OpenAPI spec version: 1.0
 * Contact: info@bayinteractive.com
 *
 */
import {Injectable, Injector} from "@angular/core";
import {HosBaseService} from "./hos-base.service";

import {HttpResponse, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import { map } from 'rxjs/operators';
import "../rxjs-operators";
import {AppConstants} from "../../app.constants";
import {AppSettings} from "../model/AppSettings";
import {ServerMessageSettings} from '../model/ServerMessageSettings';

/* tslint:disable:no-unused-variable member-ordering */


@Injectable()
export class SettingsService extends HosBaseService {


  constructor(injector: Injector) {
     super(injector);
   }

  /**
   * Return the settings
   *
   * @param deviceType The device type
   */
  public getSettings(deviceType: string, extraHttpRequestParams?: any): Observable<AppSettings> {
    return this.getSettingsWithHttpInfo(deviceType, extraHttpRequestParams)
      .pipe(
        map((response) => {
          if (response.status === 204) {
            return undefined;
          } else {
            return response.body;
          }
        })
      );
  }

  /**
   * Return the settings
   *
   * @param deviceType The device type
   */
  public getServerMessage(deviceType: string, extraHttpRequestParams?: any): Observable<ServerMessageSettings> {
    return this.getServerMessageWithHttpInfo(extraHttpRequestParams)
      .pipe(
        map((response) => {
          if (response.status === 204) {
            return undefined;
          } else {
            return response.body;
          }
        })
      );
  }


  /**
   * Return the settings
   *
   * @param deviceType The device type
   */
  public getSettingsWithHttpInfo(deviceType: string, extraHttpRequestParams?: any): Observable<HttpResponse<Object>> {
    const path = this.getBasePath() + `/settings`;

    let queryParameters = new HttpParams();
    let headers = this.getNoLoginHeaders();

    // verify required parameter 'deviceType' is not null or undefined
    if (deviceType === null || deviceType === undefined) {
      throw new Error('Required parameter deviceType was null or undefined when calling getSettings.');
    }
    if (deviceType !== undefined) {
      queryParameters = queryParameters.set('deviceType', <any>deviceType);
    }


    // to determine the Accept header
    let produces: string[] = [
      'application/json'
    ];


    let requestOptions = {
      headers: headers,
      params: queryParameters
    };

    // https://github.com/swagger-api/swagger-codegen/issues/4037
    if (extraHttpRequestParams) {
      requestOptions = this.extendObj(requestOptions, extraHttpRequestParams);
    }

    return this.executeHttpRequest(AppConstants.RequestMethods.GET, path, requestOptions);
  }

  /**
   * Return the settings
   *
   * @param deviceType The device type
   */
  public getServerMessageWithHttpInfo(extraHttpRequestParams?: any): Observable<HttpResponse<Object>> {
    const path = this.getBasePath() + `/settings/server-message`;

    let queryParameters = new HttpParams();
    let headers = this.getNoLoginHeaders();

    // to determine the Accept header
    let produces: string[] = [
      'application/json'
    ];

    let requestOptions = {
      headers: headers,
      params: queryParameters
    };

    // https://github.com/swagger-api/swagger-codegen/issues/4037
    if (extraHttpRequestParams) {
      requestOptions = this.extendObj(requestOptions, extraHttpRequestParams);
    }

    return this.executeHttpRequest(AppConstants.RequestMethods.GET, path, requestOptions);
  }

}
